<template>
    <div id="QRCode">
        <div class="hover-QRCode" v-show="show">
            <img src="../../assets/img/code-ex.png" alt="">
            <p>扫码下载APP</p>
        </div>
        <div
            class="QRCode-btn"
            :class="show ? 'btn-focus' : null"
            @mouseenter="btnFocus()"
            @mouseleave="btnOnfocus()">
            <img :src="show ? require('../../assets/img/QRCode_hover.png') : require('../../assets/img/QRCode.png')"
                 alt="">
        </div>
    </div>
</template>

<script>
    export default {
        name: 'QRCode',
        data() {
            return {
                show: false
            }
        },
        methods: {
            btnFocus() {
                console.log(1)
                this.show = true
            },
            btnOnfocus() {
                this.show = false
            }
        }
    }
</script>

<style scoped lang="less">
    @media screen and (max-width: 1200px) {
        #QRCode {
            right: 0;
        }
    }

    @media screen and (min-width: 1200px) {
        #QRCode {
            right: calc((100% - 1200px) / 2);
        }
    }

    #QRCode {
        position: fixed;
        bottom: 200px;
        display: flex;
        align-items: flex-end;
        .QRCode-btn {
            width: 48px;
            height: 48px;
            border: 1px solid rgba(238, 238, 238, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left: 10px;
            background: white;

            > img {
                width: 28px;
                height: 28px;
            }
        }

        .btn-focus {
            transition: all .5s;
            border: 1px solid #05A082;
            background: #05A082;

            > img {
                width: 28px;
                height: 28px;
            }
        }

        .hover-QRCode {
            width: 160px;
            height: 180px;
            border: 1px solid rgba(238, 238, 238, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: white;

            img {
                width: 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/QRCode/QRCode.vue